function headerNotificationModule() {
    var __ = null;

    var component = "#header-notifcation";
    var cookie_prefix = "header_note_";
    var close_identifier = ".close-header-notice";
    var data_slug = "data-slug";

    this.init = function () {
        __ = this;

        if (!$(component).length) {
            return;
        }

        var notification_slug = $(component).attr(data_slug);
        var cookie_name = cookie_prefix + notification_slug;

        if (__.get(cookie_name) == "true") {
            return;
        } else {
            $(close_identifier).on("click", function (e) {
                e.preventDefault();
                __.set(cookie_name, "true");
                __.hide();
            });
            __.show();
        }
    };

    this.set = function (name, value, days = 90) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie =
            encodeURIComponent(name) +
            "=" +
            encodeURIComponent(value) +
            expires +
            "; path=/";
    };

    this.get = function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };

    this.show = function () {
        // The bar is rendered visible; clearing the inline style keeps its breakpoint classes in charge.
        $(component).css("display", "");
    };

    this.hide = function () {
        $(component).hide();
    };
}

module.exports = headerNotificationModule;
